import { jsx as _jsx } from "react/jsx-runtime";
export function JsonLdScript({
  schema
}) {
  return /*#__PURE__*/_jsx("script", {
    type: "application/ld+json"
    // eslint-disable-next-line react/no-danger
    ,
    dangerouslySetInnerHTML: {
      __html: JSON.stringify(schema).replace(/</g, '\\u003c')
    }
  });
}